import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { useLocation } from 'react-router-dom';
import { getIsIframePreviewUrl } from '../../utils/urls';
import { usePaymentFormContext } from '../../context/PaymentFormContext';
import { useDispatch, useSelector } from 'react-redux';
import { getBuyerOverridesLineItems } from '../../state/BuyerOverrides/selectors';
import { setIsAppliedTextVisible, setIsDiscountPending } from '../../state/DiscountCode/discountCodeSlice';
import debounce from 'transmute/debounce';
import { applyDiscount } from './ApplyDiscountHelpers';
import { useDataFetchingClient } from 'data-fetching-client';
import { jsx as _jsx } from "react/jsx-runtime";
const ApplyDiscountCodeButton = ({
  checkoutSession,
  checkoutFees,
  minimumAmount,
  isPending,
  paymentMethod
}) => {
  const client = useDataFetchingClient();
  const reduxDispatch = useDispatch();
  const {
    pathname
  } = useLocation();
  const isIframePreviewUrl = getIsIframePreviewUrl(pathname);
  const {
    formState,
    dispatch
  } = usePaymentFormContext();
  const buyerOverridesLineItems = useSelector(getBuyerOverridesLineItems);
  const debouncedHideAppliedText = debounce(2000, () => reduxDispatch(setIsAppliedTextVisible(false)));
  const handleApplyDiscountCodeButtonClick = () => {
    if (formState.get('isDiscountCodeApplied')) {
      return;
    }
    reduxDispatch(setIsDiscountPending(true));
    reduxDispatch(setIsAppliedTextVisible(true));
    debouncedHideAppliedText();
    applyDiscount({
      buyerOverrides: {
        lineItems: buyerOverridesLineItems,
        discountCode: formState.get('discountCode')
      },
      checkoutSession,
      isIframePreviewUrl,
      dispatch,
      reduxDispatch,
      minimumAmount,
      client,
      paymentMethod,
      checkoutFees
    });
  };
  return /*#__PURE__*/_jsx(Button, {
    marginInlineStart: "100",
    padding: "0",
    "data-test-id": "apply-button",
    use: "transparent",
    type: "submit",
    disabled: isPending,
    onClick: handleApplyDiscountCodeButtonClick,
    responsive: false,
    children: isPending ? /*#__PURE__*/_jsx(LoadingSpinner, {
      margin: "0",
      layout: "inline",
      size: "extra-small"
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      "data-test-id": "apply-button",
      message: "payments.applyDiscountCode"
    })
  });
};
export default ApplyDiscountCodeButton;